import Box from '../../../../Common/Box';
import {Tab, Tabs, Typography} from '@mui/material';
import ControlButton from '../../../../Common/ControlButton_BU';
import Download from '@mui/icons-material/Download';
import {createSimpleTheme} from '../../getShadowTheme';
import {downloadStringAsFile, readTextInFile} from '../../../utils';
import ColorView from '../ColorView';
import React, {useContext, useEffect, useState} from 'react';
import {ThemeContext} from "../../../../Common/Contexts";
import Save from "@mui/icons-material/Save";
import {FileInput} from "../../../../Common/FileInput";
import FileOpenOutlined from "@mui/icons-material/FileOpenOutlined";
import DarkModeSwitch from "../DarkModeSwitch";
import Button from "@mui/material/Button";
import ThemeSelect from "../ThemeSelect";
import uiStore from '../../../stores/uiStore';
import ThemeDialog from "./ThemeDialog";
import {createField} from "./utils";
import {Field} from "./interfaces";

export function ThemeSettings() {

    const {shadowTheme, themes, setTheme, setThemes} = useContext(ThemeContext);
    const partialTheme = shadowTheme.data.theme

    const [fields, setFields] = useState<Field[]>([]);
    const [saveDialogOpen, setSaveDialogOpen] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    useEffect(() => {
        const primary = createField("primary", partialTheme, "palette.primary.main", (theme, main) => {
            setTheme(createSimpleTheme(shadowTheme.name, theme.palette.mode, main, theme.palette.background.default, theme.palette.background.paper));
        })
        const background = createField("background", partialTheme, "palette.background.default", (theme, backgroundDefault) => {
            setTheme(createSimpleTheme(shadowTheme.name, theme.palette.mode, theme.palette.primary.main, backgroundDefault, theme.palette.background.paper));
        });
        const paper = createField("paper", partialTheme, "palette.background.paper", (theme, paper) => {
            setTheme(createSimpleTheme(shadowTheme.name, theme.palette.mode, theme.palette.primary.main, theme.palette.background.default, paper));
        });

        const fields = [
            primary,
            background,
            paper,
        ]
        setFields(fields);
    }, [shadowTheme.name]);


    return <Box column expand>
        <Box row padding={"15px"}>
            <Typography
                    fontSize={"16px"}
                    variant={"overline"}
                    sx={{marginRight: "auto"}}
            >
                Theme settings
            </Typography>
            <FileInput
                    onClick={async files => {
                        const text = await readTextInFile(files[0]);
                        const parsedShadowTheme = JSON.parse(text);

                        if (!parsedShadowTheme.name) {
                            throw new Error("Missing name")
                        }
                        // const theme: Theme = setScrollbarStyling<Theme>(createTheme(themeObject));
                        // const themeData: ThemeData = {
                        //     theme,
                        //     metadata: {
                        //         name: themeObject.name,
                        //         comment: "temp",
                        //         creator: {
                        //             id: "temp",
                        //             name: "temp",
                        //         }
                        //     }
                        // }
                        // const newShadowTheme = createShadowTheme(themeData);
                        const newShadowTheme = parsedShadowTheme;
                        setThemes([...themes, newShadowTheme]);
                        setTheme(newShadowTheme);
                    }}
                    // customComponent={({active}) => {
                    customComponent={() => {
                        return <ControlButton
                                label={"Import theme"}
                                icon={FileOpenOutlined}
                        />
                    }}
            />
            <ControlButton
                    label={"Download theme"}
                    icon={Download}
                    onClick={() => {
                        downloadStringAsFile(JSON.stringify(shadowTheme, null, 2), shadowTheme.name + ".json");
                    }}
            />
        </Box>

        {uiStore.isMobile && <ThemeSelect/>}

        <DarkModeSwitch
                checked={partialTheme.palette.mode === "dark"}
                sx={{marginLeft: "10px"}}
                onChange={bool => {
                    const mode = bool ? "dark" : "light"
                    setTheme(createSimpleTheme(shadowTheme.name, mode, partialTheme.palette.primary.main,
                            partialTheme.palette.background.default, partialTheme.palette.background.paper));
                }}/>
        <Tabs
                value={tabIndex}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
        >
            {
                fields.map(field => {
                    return <Tab key={field.name} label={field.name}>
                    </Tab>
                })
            }
        </Tabs>

        {fields.length > 0 &&
                <Box column width={"100%"}>
                    <Box padding={"15px"}>
                        <Typography fontSize={"14px"} variant={"overline"}>
                            {fields[tabIndex].name}
                        </Typography>
                    </Box>
                    <ColorView
                            defaultColor={fields[tabIndex].currentColor}
                            onColorUpdate={color => {
                                fields[tabIndex].currentColor = color;
                                fields[tabIndex].setColor(partialTheme, color)
                            }}/>
                </Box>}
        <Box flex={1}
             padding={"20px"}
             column
             alignItems={"center"}
             justifyContent={"flex-end"}
        >
            <Button
                    onClick={() => {
                        setSaveDialogOpen(true);
                    }}
                    endIcon={<Save/>}
                    variant="contained"
            >
                Save theme
            </Button>

            <ThemeDialog open={saveDialogOpen} onClose={() => setSaveDialogOpen(false)} theme={partialTheme}/>

        </Box>
    </Box>
}
